<!-- 修改密码 -->
 <template>
  <div class="container">
    <el-dialog v-model="dialogFormVisible" title="修改密码" width="500" center>
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-form-item label="账号" :label-width="formLabelWidth">
          <el-input
            v-model="form.username"
            autocomplete="off"
            placeholder="账号"
            disabled
          />
        </el-form-item>
        <!-- <el-form-item label="旧密码" :label-width="formLabelWidth">
          <el-input
            v-model="form.oldPassword"
            autocomplete="off"
            placeholder="旧密码"
          />
        </el-form-item> -->
        <el-form-item
          label="新密码"
          :label-width="formLabelWidth"
          prop="password"
        >
          <el-input
            v-model="form.password"
            autocomplete="off"
            placeholder="新密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="handleEdit"> 修改 </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
 <script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted } from "vue";
import { saveSysUser, findSysUserById } from "@/api/User";
import { ElMessage } from "element-plus";
const dialogFormVisible = ref(false);
const form = ref({
  username: "",
  password: "",
});
const rules = reactive({
  password: [
    { required: true, message: "请输入新密码", trigger: "blur" },
    { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" },
  ],
});
const formLabelWidth = "140px";

// 打开修改密码弹窗
const openChangePassword = () => {
  dialogFormVisible.value = true;
};

// 修改
const handleEdit = () => {
  saveSysUser(form.value).then((res) => {
    if (res.code == 200) {
      dialogFormVisible.value = false;
      ElMessage({
        message: "修改成功,请重新登录!",
        type: "success",
      });
      localStorage.clear();
      setTimeout(() => {
        location.reload();
      }, 400);
    } else {
      ElMessage({
        message: res.message,
        type: "error",
      });
    }
  });
};
/**
 * id 查询用户信息
 */
const handleInit = () => {
  findSysUserById(JSON.parse(localStorage.getItem("user")).id).then((res) => {
    if (res.code == 200) {
      form.value = { ...res.entity };
    }
  });
};
onMounted(() => {
  handleInit();
});

// 暴露
defineExpose({
  openChangePassword,
});
</script>
<style lang="scss" scoped></style>;
